import Icon from "./Icon";

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  return (
    <div className="alert alert-danger bg-danger-50 text-danger-500 border-danger-100 py-1 mt-1 text-sm radius-10">
      <div className="d-flex align-items-center gap-2">
        <Icon icon="solar:danger-triangle-linear" />
        {message}
      </div>
    </div>
  );
};

export default ErrorMessage;
